import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { CoachBundlesPage } from "src/pages/CoachBundlesPage";

export const BUNDLES_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_coach/bundles/")({
  component: CoachBundlesPage,
  validateSearch: searchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return search;
  },
  async loader({ deps }) {
    return await loaderHandler(async ({ trpc }) => {
      const pageIndex = deps.p || 0;
      const pageSize = deps.ps || BUNDLES_DEFAULT_PAGE_SIZE;

      const bundles = await trpc.bundle.list.query({
        pageIndex,
        pageSize,
      });

      return {
        data: {
          bundles,
        },
      };
    });
  },
});
